import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_LOCAL_API_URL;

const NavBar = ({ userRole }) => {
  const [unreadCount, setUnreadCount] = useState(0);
  const fetchUnread = useCallback(async () => {
    try {
      const response = await fetch(`${API_URL}/notifications?limit=1`, { headers: { token: localStorage.getItem("token") } });
      if (response.ok) setUnreadCount((await response.json()).unreadCount || 0);
    } catch { setUnreadCount(0); }
  }, []);

  useEffect(() => {
    fetchUnread();
    const update = (event) => typeof event.detail?.unreadCount === "number" ? setUnreadCount(event.detail.unreadCount) : fetchUnread();
    window.addEventListener("notifications-updated", update);
    return () => window.removeEventListener("notifications-updated", update);
  }, [fetchUnread]);

  const buttonClass = "min-h-[44px] w-full rounded-2xl border border-sky-200 bg-white px-2 py-2 text-xs font-medium text-sky-700 shadow-sm transition-colors hover:bg-sky-50 sm:w-auto sm:rounded-full sm:px-4 sm:text-base";
  const linkClass = "min-w-0 flex-1 sm:flex-none";
  return <footer className="mobile-nav fixed inset-x-0 bottom-0 z-40 border-t border-slate-200/80 bg-white/95 backdrop-blur-md sm:static sm:bg-white/85">
    <nav data-guide="main-navigation" className="app-shell flex items-center justify-center gap-1 px-2 py-2 sm:flex-wrap sm:gap-2 sm:px-3 sm:py-3" aria-label="Huvudnavigation">
      <Link className={linkClass} to="/mypage"><button className={buttonClass}>Meny</button></Link>
      {[1, 2, 4, 5].includes(userRole) && <Link className={linkClass} to="/my-groups"><button className={buttonClass}>Grupper</button></Link>}
      <Link className={linkClass} to="/invitations"><button className={buttonClass}>Inbjudningar</button></Link>
      <Link className={linkClass} to="/notifications"><button className={`relative ${buttonClass}`}>
        Notiser
        {unreadCount > 0 && <span className="absolute -right-2 -top-2 inline-flex h-6 min-w-[1.5rem] items-center justify-center rounded-full bg-red-500 px-2 text-xs font-bold text-white">{unreadCount}</span>}
      </button></Link>
    </nav>
  </footer>;
};

export default NavBar;
